import NFTListing from "./NFTListing";

export default NFTListing;
